<template>
  <div class="loader-wrapper">
    <div class="loader bg-white">
      <div class="whirly-loader"> </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "confirmPayment",
  async created() {
    if (localStorage.getItem('upgrading') && window.atob(localStorage.getItem('upgrading')) === 'upgrading') {
      if(this.$route.params.uid) {
        try {
          await this.$store.dispatch('subscribeTier', window.atob( this.$route.params.uid))
          localStorage.setItem('status', '1')
          this.$router.push('/')
        } catch {
          this.$router.push('/upgrade?e=1')
        }
      } else {
        this.$router.push('/upgrade?e=1')
      }
    } else {
      this.$router.push('/upgrade?e=1')
    }
    localStorage.removeItem('upgrading')
  }
}
</script>

<style scoped>

</style>
